import { render, staticRenderFns } from "./ConsumptionFrequencyAnalysis.vue?vue&type=template&id=52527996&scoped=true"
import script from "./ConsumptionFrequencyAnalysis.vue?vue&type=script&lang=js"
export * from "./ConsumptionFrequencyAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionFrequencyAnalysis.vue?vue&type=style&index=0&id=52527996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52527996",
  null
  
)

export default component.exports